import Accordion from './components/Accordion.js';
import Carousel from './components/Carousel.js';
import DarkMode from './components/DarkMode.js';
import Form from './components/Form.js';
import Header from './components/Header.js';
import Modal from './components/Modal.js';
import Scroller from './components/Scroller.js';
import Scrolly from './components/Scrolly.js';
import TextAnim from './components/TextAnim.js';
import YouTube from './components/YouTube.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Header,
      Form,
      Carousel,
      Modal,
      Scrolly,
      Accordion,
      DarkMode,
      Scroller,
      TextAnim,
      YouTube,
    };
    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
